module.exports = __webpack_public_path__ + "static/img/icon-cart-s.68f0c14.png";


//////////////////
// WEBPACK FOOTER
// ./src/view/shopping/images/icon-cart-s.png
// module id = Mn34
// module chunks = 21